/**
 * Session-scoped "arrived from the recommendation section" attribution (P1D-5464 FR-41/42).
 * Written on card click, read by the route page-view tracker. Public ids and filter tokens
 * only — no user data. Ignored after 30 minutes.
 */
const KEY = "search_recommendation_click";
const TTL_MS = 30 * 60 * 1000;
export const SEARCH_RECOMMENDATIONS_SOURCE = "search_recommendations";

export type SearchRecommendationClick = {
  canonical_name: string;
  step_index: number;
  removed_filters: string[];
};

export const setSearchRecommendationAttribution = (data: SearchRecommendationClick) => {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({ ...data, ts: Date.now() }));
  } catch {
    // storage unavailable — attribution is best-effort
  }
};

/** Props to merge into a property page view event, or null when it does not apply. */
export const getSearchRecommendationAttribution = (pathname: string) => {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw) as SearchRecommendationClick & { ts: number };
    if (!data?.canonical_name || Date.now() - data.ts > TTL_MS) return null;
    if (!pathname.replace(/\/$/, "").endsWith(`/places/${data.canonical_name}`)) return null;
    return {
      source: SEARCH_RECOMMENDATIONS_SOURCE,
      recommendation_step_index: data.step_index,
      recommendation_removed_filters: data.removed_filters,
    };
  } catch {
    return null;
  }
};
